const BOOKS_URL = 'https://raw.githubusercontent.com/IOINITID/book-store/master/src/assets/api/books.json';

export { BOOKS_URL };
